import { Button, Title } from "@justhome/react-ui";
import {
  EventHandler,
  FC,
  PropsWithChildren,
  ReactElement,
  SyntheticEvent,
} from "react";
import { useTranslation } from "react-i18next";

interface FormStepProps {
  title: string;
  description?: string | ReactElement;
  onSubmit: EventHandler<SyntheticEvent>;
  onBack: VoidFunction;
}

const FormStep: FC<PropsWithChildren<FormStepProps>> = ({
  title,
  description,
  children,
  onSubmit,
  onBack,
}) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-12 gap">
      <div className="col-span-12 m:col-span-8 m:col-start-3 m:text-center">
        <Title as="h3" className="text-h2 mb-2xs text-balance">
          {title}
        </Title>
        <p className="text-body-2">{description}</p>
      </div>
      <form
        onSubmit={onSubmit}
        className="col-span-12 s:col-span-6 s:col-start-4 m:col-span-4 m:col-start-5"
      >
        {children}
        <div className="flex justify-between gap mt-3s">
          <Button variant="ghost" paddingX={false} size="md" onClick={onBack}>
            {t("common.back")}
          </Button>
          <Button
            iconEnd="Right"
            size="md"
            type="submit"
            data-testid="next-submit"
          >
            {t("common.continue")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default FormStep;
